export default __webpack_public_path__ + "static/media/jee.fa84a548.png";